module.exports = __webpack_public_path__ + "static/Death_Knight-57c00af28b57143a1c47d63845626462.jpg";